import React from "react";
import { Link } from "react-router-dom";

const PageNotFound = () => {
  return (
    <div
      className="container d-flex justify-content-center align-items-center text-center my-3"
      style={{
        minHeight: "100vh",
        backgroundColor: "#fff",
        padding: "2rem",
      }}
    >
      <div>
        <h1 className="display-4 font-weight-bold">404</h1>
        <h4 className="mb-3" style={{ color: "#325ba6" }}>
          Page Not Found
        </h4>
        <p className="text-muted mb-4">
          The page you are looking for does not exist.
        </p>
        <Link to="/landing-page" className="btn btn-primary">
          ← Back to Home
        </Link>
      </div>
    </div>
  );
};

export default PageNotFound;
